module.exports = __webpack_public_path__ + "static/media/pensu.34e571b7.jpg";